/* eslint-disable */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService, ResourceHelper} from "../../util/http-services";
import {EmptyMessage, IdentityMessage} from "../../util/messages";
import {ResourceQueryResult} from "../../util/services";

/* eslint-enable */

@Injectable()
export class TaskRecordOutgoingSmsResourceService extends BaseHttpService {

  query(request: OutgoingSmsResource.TaskRecordQueryRequest): Observable<ResourceQueryResult<OutgoingSmsResource.OutgoingSms>> {
    return this.http.get<ResourceQueryResult<OutgoingSmsResource.OutgoingSms>>
    (this.url + `${request.task_id}/records/${request.task_record_id}/sms/outgoing`,
      this.parseParams(request));
  }

  send(request: OutgoingSmsResource.SendRequest): Observable<IdentityMessage> {
    return this.http.post<IdentityMessage>(this.url + `${request.task_id}/records/${request.task_record_id}/sms/outgoing`, request);
  }

  constructor(private http: HttpClient, private resourceHelper: ResourceHelper) {
    super(resourceHelper, '/tasks/');
  }

}

export namespace OutgoingSmsResource {

  export interface OutgoingSms {
    id?: number;
    content?: string;
    recipient?: string;
    state?: string;
    integration_type?: string;
    send_mode?: string;
    delivery_time?: string;
    message_id?: string;
    status_code?: number;
    status_info?: string;
    error_status_code?: string;
    response_received?: boolean;
    bip_state?: string;
    bip_state_message?: string;
    bip_state_timestamp?: string;
    resend_count?: number;
    granted_rights?: string[];
    task_records?: {
      id: number;
      task_id: number;
      name: string;
    }[];
  }

  export interface TaskRecordQueryRequest {
    task_id: number;
    task_record_id: number;
    fields?: string;
    filter?: string;
    order?: string;
    page_number?: number;
    number_of_items?: number;
    rights?: string;
  }

  export interface SendRequest {
    task_id: number;
    task_record_id: number;
    previous_sms_id?: number;
    phone_number: string;
    message: string;
    integration_type: string;
  }
}
